import React from "react";

function renderComponent(Component, props = {}) {
    return <Component {...props} />;
}

export default renderComponent;
